module.exports = __webpack_public_path__ + "static/media/amela.879a5b7d.svg";